<template>
  <div class="OAModal">
    <el-dialog
      :visible.sync="visibleCopy"
      :width="width"
      @close="onCancel"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :title="title"
      top="5vh"
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "OAModal",
  props: ["title", "visible"],
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "600px",
    },
  },
  data() {
    return {
      visibleCopy: false,
    };
  },
  methods: {
    onCancel() {
      this.$emit("on-cancel");
    },
  },
  watch: {
    visible: {
      handler: function (val, oldVal) {
        this.visibleCopy = val;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/OAModal/OAModal.vue